import React, { CSSProperties, useEffect, useState } from 'react';
import RootStore from '../../store/RootStore';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';
import {IComponentNavigator, IComponentContainer, IComponent} from '../../component.d';
import { getPageSameType, isIphoneX } from '../../utils/util';
import useTheme from '../hooks/useTheme';
import ReactSVG from 'react-svg';
import {alpha} from '../../utils/color';
import './AllForBottom.scss';

export interface IAllForBottom {
  rootStore?:RootStore;
  currentTab:string;
  onTabClick:(tab:INavigatorTab)=>void;
  tabs:INavigatorTab[];
  component?:any;
}

export interface INavigatorTab {
  type:string;
  icon:string;
  active:string;
  text:string;
  useBack?:boolean;
}

const Index = (props:IAllForBottom)=>{
  const {currentTab, onTabClick, tabs, component} = props;
  const {pageDetail, configDetail} = window;

  const theme = useTheme();

  const getScreenBottom = ()=>{
    return isIphoneX() ? 22 : 0;
  };

  return <div className="all-for-bottom">
    {tabs && tabs.length > 1 ? <div className="bottom-tab" style={{ 
      paddingBottom:getScreenBottom(),
      backgroundColor: component && component.container && component.container.useThemeColor === false ? component.container.componentBg : alpha(theme.componentColor, 1),
    }}>
      {tabs.map((it:INavigatorTab, index:number)=>{
        let isActive = currentTab === it.type;
        return <div className="bottom-tab-one" key={index} onClick={()=>{
          onTabClick(it);
        }}>
          <ReactSVG
            src={isActive ? it.active : it.icon}
            className="tab-icon"
            style={{ color: isActive ? theme.mainColor : theme.h2Color, fill: isActive ? theme.mainColor : theme.h2Color }}
          />
          <div className="tab-name" style={{color: isActive ? theme.mainColor : theme.h2Color}}>{it.text}</div>
        </div>;
      })}
    </div> : null}
  </div>;
};

export default inject('rootStore')(observer(Index));
